module.exports = __webpack_public_path__ + "static/media/Chart.3a8cb510.png";